module.exports = __webpack_public_path__ + "public/images/autocomplete-close.8a64d8c1b6a111e7b10b6748567b2a89.svg";